import { ChecklistStatus } from '../../common/DocPage.types';
export const BreadcrumbStatus = {
  keyboardAccessibilitySupport: ChecklistStatus.good,
  markupSupport: ChecklistStatus.good,
  highContrastSupport: ChecklistStatus.pass,
  rtlSupport: ChecklistStatus.pass,
  testCoverage: ChecklistStatus.fair
};
